module.exports = __webpack_public_path__ + "media/win.97cd04f2.mp3";